import React, { useState } from "react";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";

const FEATURES = [
  ["Eye", "welcome_f1"],
  ["TriangleAlert", "welcome_f2"],
  ["Vote", "welcome_f3"],
  ["Home", "welcome_f4"],
];

export const WelcomeModal = () => {
  const { t } = useApp();
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!user || user.welcome_seen || user.role === "president") return null;

  const dismiss = async () => {
    setBusy(true);
    setUser({ ...user, welcome_seen: true });
    try { await api.post("/auth/me/welcome-seen"); } catch (e) { console.warn("welcome: échec enregistrement (réaffichée à la prochaine connexion)", e?.message); }
  };

  return (
    <div className="fixed inset-0 z-[90] bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="welcome-modal">
      <div className="bg-card text-foreground rounded-3xl w-full max-w-md shadow-ios-lg overflow-hidden max-h-[88vh] overflow-y-auto animate-rise">
        <div className="bg-gradient-to-br from-brand-dark to-brand text-white p-6">
          <div className="h-12 w-12 rounded-2xl bg-white/15 flex items-center justify-center mb-3">
            <Icons.Building2 className="h-6 w-6" />
          </div>
          <h2 className="text-2xl font-black leading-tight" data-testid="welcome-title">
            {t("welcome_title")}{user.name ? `, ${user.name.split(" ")[0]}` : ""}
          </h2>
          <p className="text-white/80 text-sm mt-1">{t("welcome_sub")}</p>
        </div>
        <div className="p-6 space-y-4">
          {FEATURES.map(([ic, key]) => {
            const Ico = Icons[ic];
            return (
              <div key={key} className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-xl bg-brand/10 text-brand dark:text-primary flex items-center justify-center shrink-0">
                  <Ico className="h-4.5 w-4.5" style={{ height: 18, width: 18 }} />
                </div>
                <p className="text-sm leading-relaxed pt-1.5">{t(key)}</p>
              </div>
            );
          })}
          <button onClick={dismiss} disabled={busy} data-testid="welcome-dismiss-btn"
            className="w-full h-14 rounded-full bg-brand text-white font-bold text-lg mt-2 active:scale-[0.98] transition-transform disabled:opacity-60">
            {t("welcome_cta")}
          </button>
        </div>
      </div>
    </div>
  );
};
